/**
 * Chat Socket.io Connection Utility (Admin)
 * Manages socket connection with authentication for the chat module.
 * Adapted from DOUBTQ CHATBOT for the main Admin frontend.
 */

import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_CHAT_API_URL || 'http://localhost:5001';

let socket = null;

/**
 * Initialize socket connection
 * @param {string} token - JWT admin auth token
 * @returns {Socket} socket instance
 */
export const initChatSocket = (token) => {
    if (socket?.connected) {
        return socket;
    }

    socket = io(SOCKET_URL, {
        auth: {
            token,
        },
        transports: ['websocket', 'polling'],
    });

    socket.on('connect', () => {
        console.log('Admin Chat socket connected');
    });

    socket.on('disconnect', () => {
        console.log('Admin Chat socket disconnected');
    });

    socket.on('error', (error) => {
        console.error('Admin Chat socket error:', error);
    });

    return socket;
};

/**
 * Get current socket instance
 * @returns {Socket|null}
 */
export const getChatSocket = () => socket;

/**
 * Disconnect socket
 */
export const disconnectChatSocket = () => {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
};

export default {
    initChatSocket,
    getChatSocket,
    disconnectChatSocket,
};
